import gql from 'graphql-tag';

const GET_TRANSLATION = gql`
  query GetTranslation($word: String!, $lesson_id: Int!, $program_id: Int!) {
    translation(word: $word, lesson_id: $lesson_id, program_id: $program_id) {
      original
      regularForm
      translated
      source
      recordExist

      dictionary {
        word
        pronunciation
        inflection
        meaning
        example
      }

      logMsg {
        info
        cacheKey
        data {
          vocabulary_id
          lesson_id
          program_id
          level_id
          rank_id
          word
          translation
          dictionary_data
          language
          type_of_word
          example_sentence
          status
          created_at
          updated_at
        }
      }
    }
  }
`;

export { GET_TRANSLATION };
